var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51164 1.25748L8.74252 0.488358C8.43002 0.1754 8.00629 0 7.56416 0H1.14586C0.512924 0 0 0.512924 0 1.14586V8.85414C0 9.48708 0.512924 10 1.14586 10H8.85414C9.48708 10 10 9.48708 10 8.85414V2.43584C10 1.99371 9.8246 1.56998 9.51164 1.25748ZM1.66664 2.60414V1.5625C1.66664 1.39 1.80664 1.25 1.97914 1.25H6.35414C6.52664 1.25 6.66664 1.39 6.66664 1.5625V2.60414C6.66664 2.77664 6.52664 2.91664 6.35414 2.91664H1.97914C1.80664 2.91664 1.66664 2.77664 1.66664 2.60414ZM5 8.33336C3.96461 8.33336 3.125 7.49374 3.125 6.45836C3.125 5.4229 3.96461 4.58336 5 4.58336C6.03539 4.58336 6.875 5.4229 6.875 6.45836C6.875 7.49374 6.03539 8.33336 5 8.33336Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconHover);
export default __webpack_public_path__ + "static/media/saveIconHover.63b0ff78c188274773cf64eb01c447f7.svg";
export { ForwardRef as ReactComponent };